import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {DataService} from '../data.service';
import {Constant} from '../constant';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';


declare var $: any;
declare var toastr: any;
declare var window: Window;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  apiAddress = Constant.apiAddressHttp;

  submit = false;

  public name = '';
  public email = '';
  public message = '';
  public phone = '';
  public topic = '';
  public type = 'CamdenHealth';
  public mailData: any;

  partnersData = [];
  blogData = [];
  blogMobileData = [];


  constructor(private formBuilder: FormBuilder, private dataService: DataService, private meta: Meta, private title: Title,
              private router: Router) {
    // document.body.scrollTop = 0;


    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  ngOnInit(): void {

    this.title.setTitle('Camden Health System | Democratizing Healthcare');

    // Google / Search Engine Tags
    this.meta.updateTag({ property: 'name', content: 'Camden Health System | Democratizing Healthcare' });
    this.meta.updateTag({ property: 'description', content: 'Camden Health System offers affordable, scalable and secure healthcare IT solutions including HMIS & analytics for health management, monitoring and research.' });
    this.meta.updateTag({ property: 'image', content: 'https://camdenhealthsys.com/assets/images/camden-logo.png' });

    // Facebook Meta Tags
    this.meta.updateTag({ property: 'og:url', content: 'https://camdenhealthsys.com' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:title', content: 'Camden Health System | Democratizing Healthcare' });
    this.meta.updateTag({ property: 'og:description', content: 'Camden Health System offers affordable, scalable and secure healthcare IT solutions including HMIS & analytics for health management, monitoring and research.' });
    this.meta.updateTag({ property: 'og:image', content: 'https://camdenhealthsys.com/assets/images/camden-logo.png' });

    // Twitter Meta Tags
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: 'Camden Health System | Democratizing Healthcare' });
    this.meta.updateTag({ name: 'twitter:description', content: 'Camden Health System offers affordable, scalable and secure healthcare IT solutions including HMIS & analytics for health management, monitoring and research.' });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://camdenhealthsys.com/assets/images/camden-logo.png' });

    this.getBlogs();
    this.getPartner();

    // $('.industries-slider').owlCarousel({
    //   dots: true,
    //   dotData: true,
    //   autoplay: false,
    //   lazyLoad: true,
    //   loop: false,
    //   responsiveClass: true,
    //   autoHeight: true,
    //   autoplayTimeout: 7000,
    //   smartSpeed: 800,
    //   nav: false,
    //   responsive: {
    //     0: {
    //       items: 2,
    //     },
    //     600: {
    //       items: 3,
    //     },
    //     800: {
    //       items: 4,
    //     },
    //     1000: {
    //       items: 5,
    //     }
    //   }
    // });

    $('body').scrollspy({
      target: '.navbar',
      offset: 160
    });

    $('nav a, .sidenav a').bind('click', function() {
      $('html, body').stop().animate({
        scrollTop: $($(this).attr('href')).offset().top - 100
      }, 1500, 'easeInOutExpo');
      event.preventDefault();
    });

    $('.navbar-inverse li a').click(function(event) {
      $('.navbar-collapse').collapse('hide');
    });

    // $('.sidenav a').sidenav().on('click tap', 'a', () => {
    //     $('.sidenav').sidenav('close');
    //   });

    // const myDiv = $('.text-rest');
    // myDiv.text(myDiv.text().substring(0, 500) + '...');

  }

  initStorySlider(): void{
    setTimeout( () => {
      $('.story-slider').owlCarousel({
        dots: true,
        dotData: true,
        autoplay: false,
        lazyLoad: true,
        loop: false,
        responsiveClass: true,
        autoHeight: true,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          }
        }
      });
    }, 1000);
  }

  getBlogs(): void{
    this.dataService.getBlogListing().subscribe(
      (data) => {
        this.blogData = data;
        var obj = [];
        for ( var i = 0; i < this.blogData.length; i++ ) {
          obj.push(this.blogData[i]);
          if ( obj.length === 2 ) {
            this.blogMobileData.push(obj);
            obj = [];
          }
        }
        console.log('blogMobileData', this.blogMobileData);
        // this.initStorySlider();
      },
      (error) => {
      }
    );
  }

  getPartner(): void{
    this.dataService.getPartnerListing().subscribe(
      (data) => {
        this.partnersData = data;
        if ( this.partnersData.length > 0 ) {
         setTimeout( () => {
          $('.clientSlider').owlCarousel({
      dots: true,
      dotData: true,
      autoplay: true,
      lazyLoad: true,
      loop: true,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 5000,
      smartSpeed: 400,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 4,
        },
        800: {
          items: 6,
        },
        1000: {
          items: 8,
        }
      }
    });
        }, 500 );
        }
      },
      (error) => {
      }
    );
  }


  openNav(): any {
    document.getElementById('mySidenav').style.width = '250px';
  }

  closeNav(): any {
    document.getElementById('mySidenav').style.width = '0';
  }


  validateEmail(email): any {
    // tslint:disable-next-line:max-line-length
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  onSubmit(): any {
    // this.submit = true;


    if ( this.name === '' ) {
      toastr.error('Please enter name');
      return;
    }
    if ( this.email === '' ) {
      toastr.error('Please enter email');
      return;
    }
    if ( this.validateEmail(this.email) === false ) {
      toastr.error('Please enter valid email');
      return;
    }
    if ( this.message === '' ) {
      toastr.error('Please enter message');
      return;
    }
    this.submit = true;
    this.dataService.sendMail(this.name, this.email, this.message, this.topic,  this.phone).subscribe(
      (data) => {
        toastr.success('Message has been send successfully');
        this.submit = false;
        this.mailData = data;
        this.name = '';
        this.email = '';
        this.message = '';
        this.phone = '';
      },
      (error) => {
        toastr.error('Something went wrong, please try again later');
        this.submit = true;
      }
    );

  }

  onlyNumeric(event: any): any {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }


  // changeSelect(event: any): any {
  //   if (event.target.value === '') {
  //     console.log(event);
  //     console.log('yes');
  //     event.target.style.color = 'white';
  //     console.log(event.target);
  //   }
  // }

}
